export interface MenuOption {
  code: string;
  text: string;
  href: string;
}


export const menuOptions: MenuOption[] = [
  {
    code: '0001',
    text: 'Menú de gestión de roles y opciones asociadas',
    href: 'listas/0001',
  },
  {
    code: '0002',
    text: 'Generar reporte roles y opciones asociadas',
    href: 'listas/0002',
  },
  {
    code: '1001',
    text: 'Adición de Personas en Lista de Control',
    href: 'listas/1001',
  },
  {
    code: '1002',
    text: 'Adición y retiro de categorías y subcategorías',
    href: 'listas/1002',
  },
  {
    code: '1003',
    text: 'Modificación de Información Personal',
    href: 'listas/1003',
  },
  {
    code: '1004',
    text: 'Consulta de Listas de Control',
    href: 'listas/1004/filtro',
  },
  {
    code: '1007',
    text: 'Consulta por categorías de listas de control',
    href: 'listas/1007/tablas',
  },
  {
    code: '1008',
    text: 'Conversión de Archivos a Listas de Control',
    href: 'listas/1008/tabla',
  },
  { code: '1009', text: 'Mantenimiento de Categorías', href: 'listas/1009' },
  {
    code: '1010',
    text: 'Mantenimiento de subcategorías',
    href: 'listas/1010',
  },
  { code: '1011', text: 'Mantenimiento de Mensajes', href: 'listas/1011' },
  {
    code: '1012',
    text: 'Mantenimiento de Usuarios y Sistemas',
    href: 'listas/1012/maintenance-users',
  },
  { code: '1013', text: 'Listas de Control', href: 'listas/1013/filtro' },
  {
    code: '1014',
    text: 'Parametrización de Sistemas',
    href: 'listas/1014/tabla',
  },
  {
    code: '1015',
    text: 'Cambio a Vigente - No vigente Categ. LC',
    href: 'listas/1015/tabla',
  },
  {
    code: '1016',
    text: 'Parametrización de Archivos',
    href: 'listas/1016/tabla',
  },
  {
    code: '1017',
    text: 'Retiro o modificación de registros de persona',
    href: 'listas/1017',
  },
  {
    code: '1018',
    text: 'Retiro o modificación de registros de categoría',
    href: 'listas/1018',
  },
  {
    code: '1019',
    text: 'Depuración de Información Personal (LPE)',
    href: 'listas/1019',
  },
  {
    code: '1020',
    text: 'Depuración Categorías Y Subcategorías (LMI)',
    href: 'listas/1020',
  },
  { code: '1021', text: 'Parametrizar Usuarios Depuración', href: 'listas/1021' },
  { code: '1022', text: 'Depuración automática', href: 'listas/1022' },
  { code: '1025', text: 'Consulta de histórico de listas OFAC y ONU', href: 'listas/1025' },
  {
    code: '1026',
    text: 'Resumen actividades manuales listas OFAC/ONU',
    href: 'listas/1026',
  },
  {
    code: '1029',
    text: 'Consulta de listas de control - abogados externos',
    href: 'listas/1029/filtro',
  },
  { code: '1030', text: 'Mantenimiento Log Finacle', href: 'listas/1030' },
  {
    code: '1031',
    text: 'Generación de archivo BVCFFCTLGO',
    href: 'listas/1031',
  },
  {
    code: '1032',
    text: 'Mantenimiento de áreas prioridades y mensajes de gestión',
    href: 'listas/1032',
  },
  {
    code: '1033',
    text: 'Mantenimiento de clientes homónimos',
    href: 'listas/1033/info',
  },
  {
    code: '1034',
    text: 'Desbloqueos temporales en Lista de Control',
    href: 'listas/1034/search-people-unlocked',
  },
  {
    code: '1035',
    text: 'Consulta de log de servicio de lista de control',
    href: 'listas/1035/filtro',
  },
  {
    code: '1036',
    text: 'Métodos de búsqueda de lista de control - consulta',
    href: 'listas/1036/filtro',
  },
  {
    code: '1037',
    text: 'Evaluación de Respuestas en Listas de Control',
    href: 'listas/1037',
  },
  {
    code: '1039',
    text: 'Sistema de cambios masivos en listas de control',
    href: 'listas/1039',
  },
  {
    code: '1040',
    text: 'Mantenimiento parámetros generales',
    href: '/listas/1040/tabla',
  },
];
